import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * CriticalCare icon
 *
 * @category Medical
 */
const CriticalCare = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.899 23.043c-1.33-.39-2.75 0-2.75-1.54-.15-2.34.29-5.42-.54-7.62-1.74-5.45-9.78-6.31-12.62-1.23-1.32 2.23-1.07 4.41-1.09 7.01-.06 1.26.19 2.13-.37 2.8-.49.52-1.93.25-2.74.8-.89.63-.88 2.03-.54 2.97.45 1.35 1.61.94 2.75 1.01h16.36c.75-.04 1.44.16 2.02-.34.76-.7.91-3.35-.34-3.78l-.15-.06zm-15.88-7.11c.63-7.04 10.39-7.72 11.85-.79.34 1.72.16 3.64.2 5.54 0 1.04 0 1.71-.42 1.96-.65.33-1.36.19-2.36.23-2.88.11-2.83-.2-2.78-2.92.03-.83-.1-1.7.16-2.46.26-.74 1.39-.68 1.96-1.01 1.57-.99-5.49-.9-5.5-.31.19.75 1.95.41 2.21 1.32.26.74.13 1.5.16 2.46-.07 1.06.21 1.88-.33 2.62-.54.43-1.66.26-2.45.3-.75-.02-1.51.05-2.14-.12-.98-.47-.52-1.55-.64-2.8.01-1.48-.04-2.54.05-3.84l.02-.16zm15.73 10.04c-1.28.46-3.08.1-4.45.21-2.98-.16-10.96.31-14.82-.18-.63-.37-.71-2.07.22-2.17 5.56-.07 12.03 0 17.48-.03.62.06 1.07-.15 1.55.2.44.38.27 1.62.09 1.88l-.07.08zM16.07 7.753c.42-.11.47-.48.44-.95-.07-.6.17-1.42-.16-1.91-.87-.53-.87.52-.84 1.35.05.57-.2 1.33.44 1.51zm6.599 2.46 1.11-1.11c.19-.2.26-.25.34-.36.29-.34-.08-.98-.57-.77-.42.23-.89.85-1.29 1.21-.29.31-.39.3-.45.68 0 .43.46.58.8.39l.06-.05zm-13.249.05c.64.38 1.12-.48.5-.92-.5-.34-1.52-2.08-2.08-1.1-.12.44.1.54.41.87l1.11 1.11.06.05z"
        />
      </svg>
    );
  }
);

CriticalCare.displayName = 'CriticalCare';

export { CriticalCare };
